/**
 * Validated view over the build-time environment. Reading `import.meta.env`
 * anywhere else is discouraged: a missing base URL should fail loudly here
 * rather than produce requests to `undefined/...`.
 */
function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Missing ${String(name)}. Copy .env.example to .env and set it.`);
  }
  return String(value);
}

export const env = {
  apiBaseUrl: required('VITE_API_BASE_URL'),
  appEnv: import.meta.env.VITE_APP_ENV ?? 'development',
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? null,
  /**
   * Where this site is served, for canonical URLs and structured data.
   *
   * Configured rather than read from `window`, because the public pages are
   * also rendered at build time — where there is no window, and where a wrong
   * canonical would be baked into the HTML a crawler reads.
   */
  siteUrl: (import.meta.env.VITE_PUBLIC_SITE_URL ?? 'http://localhost:5173').replace(/\/$/, ''),
  get isProduction(): boolean {
    return this.appEnv === 'production';
  },
} as const;
